import { render, staticRenderFns } from "./ComplianceContactsInfo.vue?vue&type=template&id=7df90430&scoped=true&"
import script from "./ComplianceContactsInfo.vue?vue&type=script&lang=ts&"
export * from "./ComplianceContactsInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ComplianceContactsInfo.vue?vue&type=style&index=0&id=7df90430&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df90430",
  null
  
)

export default component.exports